import { useEffect, useState } from "preact/hooks";
import { getProductTypeRevision, ManufacturingConfiguration, ProductTypeRevision } from "../api/product-api";
import { manufacturingConfigurations } from "../App";

export function useRevisions(type: string) {
    const [manufacturingConfiguration, setManufacturingConfiguration] = useState(
        null as null | ManufacturingConfiguration,
    );
    const [revisions, setRevisions] = useState([] as ProductTypeRevision[]);
    const [currentRevision, setCurrentRevision] = useState(null as ProductTypeRevision | null);

    useEffect(() => {
        const config =
            Object.values(manufacturingConfigurations)
                .flat()
                .find(v => v?.productType.name === type) ?? null;

        if (!config) {
            setManufacturingConfiguration(null);
            return;
        }

        (async () => {
            const revisions = await Promise.all(
                config.productType.productTypeRevisions!.map(r => getProductTypeRevision(r.id)),
            );

            setRevisions(revisions);

            if (revisions.length === 1) {
                setCurrentRevision(revisions[0]);
            }

            const currentRevision = revisions.find(v => v.id === config.productType.currentProductTypeRevision?.id);

            if (currentRevision) {
                setCurrentRevision(currentRevision);
            }

            setManufacturingConfiguration(config);
        })();
    }, [type]);

    return { manufacturingConfiguration, revisions, currentRevision };
}
